import './App.css';

function App() {
  return (
    <div className="App">
      <div className="container">

        {/* Header */}
        <h1>Pooja Sharma</h1>
        <h3>Game Developer</h3>

        <p className="about">
          Game Developer with 5+ years of experience in mobile and 3D game development.
          Specialized in casino/slot games, physics-based mechanics, and multiplayer
          casual games. Skilled in Unity and C#, delivering high-performance and
          engaging gameplay experiences.
        </p>

        {/* Experience */}
        <h2>Professional Experience</h2>
        <div className="experience">

          <div className="exp-card">
            <h4>🏢 Intopros Technology</h4>
            <p>
              Worked on core game development using Unity. Focused on gameplay logic,
              debugging, and improving performance of mobile games. Contributed to
              early-stage game architecture and feature implementation.
            </p>
          </div>

          <div className="exp-card">
            <h4>🏢 RPA Nepal</h4>
            <p>
              Developed interactive applications and automation-based solutions.
              Gained experience in logic building, system workflows, and integrating
              technical solutions with user-friendly interfaces.
            </p>
          </div>

          <div className="exp-card">
            <h4>🏢 Himath Technology</h4>
            <p>
              Worked on 3D game development using Unity. Implemented physics-based
              mechanics including ball movement systems, collision handling, and
              level design for engaging gameplay experiences.
            </p>
          </div>

          <div className="exp-card">
            <h4>🏢 Gamekunda</h4>
            <p>
              Developed and maintained popular casual games like Ludo and Call Break.
              Worked on multiplayer features, UI systems, and game optimization.
              Delivered smooth gameplay and scalable architecture.
            </p>
          </div>

          <div className="exp-card">
            <h4>🏢 Yarsa Games</h4>
            <p>
              Specialized in casino and slot game development. Designed reward systems,
              animations, and engaging user experiences. Focused on monetization,
              performance optimization, and polished UI/UX.
            </p>
          </div>

        </div>

        {/* Projects */}
        <h2>Projects</h2>
        <div className="projects">

          <div className="card">
            <h4>🎮 Ludo Game</h4>
            <a
              href="https://play.google.com/store/apps/details?id=com.gamekunda.games.ludo"
              target="_blank"
              rel="noopener noreferrer"
            >
              View on Play Store
            </a>
          </div>

          <div className="card">
            <h4>🎴 Call Break Game</h4>
            <a
              href="https://play.google.com/store/apps/details?id=com.gamekunda.games.callbreak"
              target="_blank"
              rel="noopener noreferrer"
            >
              View on Play Store
            </a>
          </div>

          <div className="card">
            <h4>🧠 Memory Match Game</h4>
            <a
              href="https://play.google.com/store/apps/details?id=com.gamekunda.games.memorymatch&hl=en-US"
              target="_blank"
              rel="noopener noreferrer"
            >
              View on Play Store
            </a>
          </div>

        </div>

        {/* Skills */}
        <h2>Skills</h2>
        <div className="skills">
          <span>Unity</span>
          <span>C#</span>
          <span>3D Game Development</span>
          <span>Game Physics</span>
          <span>Multiplayer Systems</span>
          <span>UI/UX Design</span>
          <span>Mobile Game Development</span>
        </div>

        {/* Contact */}
        <h2>Contact</h2>
        <p>Email: pujasharma2058@gmail.com</p>

      </div>
    </div>
  );
}

export default App;
